export class BmsCustomerUser {
  id : string;
  customerId : string;
  customerName : string;
  firstname : string;
  surname : string;
  email : boolean;
}
